export const build = { date:"2026-04-30.1242", stage:"alpha" }
